// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/home/hp-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/images/banner/homepage-mob-banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.home_banner {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  height: 31.3vw;
  box-shadow: 0 10px 10px 0 rgb(0 0 0 / 10%);
}

.banner_txt {
  position: relative;
  font-family: "Poppins", sans-serif;
  font-size: 48px;
  /* text-transform: capitalize; */
  font-weight: 600;
  color: #112f48;
  text-align: left;
}
.ver-line::after {
  content: "";
  position: absolute;
  height: 10px;
  border-radius: 10px;
  width: 35%;
  background: rgb(166, 203, 70);
  bottom: -35px;
  left: 0px;
}
/* .banner_txt span {
  color: var(--dPink);
} */
.home_bird {
  height: 65px;
  width: auto;
  margin-bottom: 20px;
}
a.home_banner_btn {
  background: var(--dBlue);
  border-radius: 50px;
  padding: 12px 30px;
  color: #fff;
  text-align: left;
  float: left;
  margin-top: 25px;
  font-weight: 700;
}
section.home_banner p {
  margin: 15px 0px;
  font-size: 35px;
  font-family: "Nunito Sans", sans-serif;
  font-weight: 700;
  padding-top: 25px;
}
.banner_btn {
  background: transparent;
  border: 4px solid rgb(110, 90, 200);
  color: black;
  font-size: 18px;
  padding: 7px 30px;
  border-radius: 25px;
}
a.home_banner_btn:hover {
  color: #fff;
}
.banner_img img:first-child {
  display: block;
}
.banner_img img:last-child {
  display: none;
}

@media (max-width: 1024px) {
  section.home_banner {
    height: 300px;
  }

  .banner_txt {
    font-size: 28px;
  }

  section.home_banner p {
    font-size: 22px;
  }
}

@media (max-width: 576px) {
  section.home_banner {
    height: 450px;
  }

  .banner_txt ::after {
    height: 5px;
    bottom: -10px;
  }

  .banner_txt {
    padding: 0px 10px;
    text-align: center;
    margin: 0px;
  }
  a.home_banner_btn {
    font-size: var(--pSize);
    text-align: center;
    float: none;
  }
  .banner_img img:first-child {
    display: none;
  }
  .banner_img img:last-child {
    display: block;
    margin-top: 20px;
  }
  .home_bird {
    height: 55px;
    margin: 20px 20px 0px 20px;
  }
  section.home_banner {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: bottom;
    /* padding: 70px 0px; */
  }
  section.home_banner .banner_txt {
    font-size: 28px;
    text-align: left;
    padding: 0px !important;
  }
  section.home_banner p {
    font-size: 18px;
    text-align: left;
  }
  .homepage_txt_container {
    position: relative;
    bottom: 80px;
  }

  .ver-line::after {
    bottom: -25px;
  }

  section.home_banner p {
    padding-top: 20px;
  }
}

@media (max-width: 1024px) {
  .pdp_banner h1::after {
    bottom: -15px !important;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .homepage_txt_container {
    margin-top: 5%;
  }

  .cardHome {
    height: 52vh !important;
  }

  .banner_txt {
    font-size: 40px;
  }

  section.home_banner p {
    font-size: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/home/banner.css"],"names":[],"mappings":"AAAA;EACE,mDAA4D;EAC5D,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,SAAS;AACX;AACA;;GAEG;AACH;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,0BAA0B;EAC5B;EACA;IACE,mDAAwE;IACxE,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["section.home_banner {\r\n  background: url(\"../../../public/images/home/hp-banner.png\");\r\n  background-position: center;\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n  display: flex;\r\n  align-items: center;\r\n  height: 31.3vw;\r\n  box-shadow: 0 10px 10px 0 rgb(0 0 0 / 10%);\r\n}\r\n\r\n.banner_txt {\r\n  position: relative;\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-size: 48px;\r\n  /* text-transform: capitalize; */\r\n  font-weight: 600;\r\n  color: #112f48;\r\n  text-align: left;\r\n}\r\n.ver-line::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 10px;\r\n  border-radius: 10px;\r\n  width: 35%;\r\n  background: rgb(166, 203, 70);\r\n  bottom: -35px;\r\n  left: 0px;\r\n}\r\n/* .banner_txt span {\r\n  color: var(--dPink);\r\n} */\r\n.home_bird {\r\n  height: 65px;\r\n  width: auto;\r\n  margin-bottom: 20px;\r\n}\r\na.home_banner_btn {\r\n  background: var(--dBlue);\r\n  border-radius: 50px;\r\n  padding: 12px 30px;\r\n  color: #fff;\r\n  text-align: left;\r\n  float: left;\r\n  margin-top: 25px;\r\n  font-weight: 700;\r\n}\r\nsection.home_banner p {\r\n  margin: 15px 0px;\r\n  font-size: 35px;\r\n  font-family: \"Nunito Sans\", sans-serif;\r\n  font-weight: 700;\r\n  padding-top: 25px;\r\n}\r\n.banner_btn {\r\n  background: transparent;\r\n  border: 4px solid rgb(110, 90, 200);\r\n  color: black;\r\n  font-size: 18px;\r\n  padding: 7px 30px;\r\n  border-radius: 25px;\r\n}\r\na.home_banner_btn:hover {\r\n  color: #fff;\r\n}\r\n.banner_img img:first-child {\r\n  display: block;\r\n}\r\n.banner_img img:last-child {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  section.home_banner {\r\n    height: 300px;\r\n  }\r\n\r\n  .banner_txt {\r\n    font-size: 28px;\r\n  }\r\n\r\n  section.home_banner p {\r\n    font-size: 22px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  section.home_banner {\r\n    height: 450px;\r\n  }\r\n\r\n  .banner_txt ::after {\r\n    height: 5px;\r\n    bottom: -10px;\r\n  }\r\n\r\n  .banner_txt {\r\n    padding: 0px 10px;\r\n    text-align: center;\r\n    margin: 0px;\r\n  }\r\n  a.home_banner_btn {\r\n    font-size: var(--pSize);\r\n    text-align: center;\r\n    float: none;\r\n  }\r\n  .banner_img img:first-child {\r\n    display: none;\r\n  }\r\n  .banner_img img:last-child {\r\n    display: block;\r\n    margin-top: 20px;\r\n  }\r\n  .home_bird {\r\n    height: 55px;\r\n    margin: 20px 20px 0px 20px;\r\n  }\r\n  section.home_banner {\r\n    background: url(\"../../../public/images/banner/homepage-mob-banner.png\");\r\n    background-size: cover;\r\n    background-position: bottom;\r\n    /* padding: 70px 0px; */\r\n  }\r\n  section.home_banner .banner_txt {\r\n    font-size: 28px;\r\n    text-align: left;\r\n    padding: 0px !important;\r\n  }\r\n  section.home_banner p {\r\n    font-size: 18px;\r\n    text-align: left;\r\n  }\r\n  .homepage_txt_container {\r\n    position: relative;\r\n    bottom: 80px;\r\n  }\r\n\r\n  .ver-line::after {\r\n    bottom: -25px;\r\n  }\r\n\r\n  section.home_banner p {\r\n    padding-top: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .pdp_banner h1::after {\r\n    bottom: -15px !important;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\r\n  .homepage_txt_container {\r\n    margin-top: 5%;\r\n  }\r\n\r\n  .cardHome {\r\n    height: 52vh !important;\r\n  }\r\n\r\n  .banner_txt {\r\n    font-size: 40px;\r\n  }\r\n\r\n  section.home_banner p {\r\n    font-size: 30px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
